import { Separator, Skeleton } from '@monksflow/monks-ui';

export function OpportunitiesCardSkeleton() {
  return (
    <div className="flex flex-col w-full bg-card border border-border-light rounded-lg">
      {/* Header */}
      <div className="flex items-center justify-between px-6 pt-6">
        <div className="flex items-center gap-3">
          <Skeleton className="h-5 w-16 rounded-sm" />
          <Skeleton className="h-3 w-12" />
        </div>
        <div className="flex items-center gap-1">
          <Skeleton className="size-9 rounded-md" />
          <Skeleton className="size-9 rounded-md" />
        </div>
      </div>

      {/* Content */}
      <div className="flex flex-col gap-4 px-6 pt-4 pb-6">
        <div className="flex items-start gap-5">
          <div className="flex flex-col gap-2 flex-1">
            <Skeleton className="h-5 w-full" />
            <Skeleton className="h-5 w-4/5" />
            <Skeleton className="h-5 w-3/5" />
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <div className="flex items-center justify-between">
            <Skeleton className="h-3 w-16" />
            <Skeleton className="h-5 w-20 rounded-full" />
          </div>
          <Separator />
          <div className="flex items-center justify-between">
            <Skeleton className="h-3 w-14" />
            <div className="flex gap-1">
              <Skeleton className="h-5 w-16 rounded-full" />
              <Skeleton className="h-5 w-16 rounded-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
